export class Region {
  Id: string;
  Name: string;
}
